import { AuditTrailEvent } from '@piccolohealth/pbs-common';
import { MultiSelect, type MultiSelectOption, type OnChangeRequest } from '@piccolohealth/ui';
import { inflection, P } from '@piccolohealth/util';
import React from 'react';
import type { AuditTrailFilter } from '../../hooks/useAuditTrailFilter';
import { getColor } from './AuditTrailEventTag';

const eventToOption = (event: AuditTrailEvent): MultiSelectOption<AuditTrailEvent> => {
  return {
    label: inflection.titleize(event),
    value: event,
    color: getColor(event),
    raw: event,
  };
};

interface Props {
  filter: AuditTrailFilter;
}

export const AuditTrailEventFilterControl = ({ filter }: Props) => {
  const { eventsFilter, onEventsFilter } = filter;

  const options = Object.values(AuditTrailEvent).map(eventToOption);

  const onChange = React.useCallback(
    (req: OnChangeRequest<AuditTrailEvent>) => {
      onEventsFilter(req.values.map(({ raw }) => raw));
    },
    [onEventsFilter],
  );

  const selectedValues = React.useMemo(() => {
    return P.compact(eventsFilter.map((v) => options.find((o) => P.isEqual(o.raw, v))));
  }, [eventsFilter, options]);

  return (
    <MultiSelect
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      placeholder='All event types'
      optionVariant='tag'
    />
  );
};
